import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { useTranslation } from "@msuite/ui/localization";
import { SettingsItem } from "@msuite/ui/settings";
import { toast } from "@msuite/ui/toast";
import React from "react";
import { Can } from "@/components/citadel";
import { MergeProjectModal } from "@/modals/projects/merge-project-modal";
import type { ProjectPanelBaseProps } from "../../types";

export function MergeProject({ projectId }: ProjectPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<SettingsItem
				title={t("projects.merge_project")}
				description={t("projects.merge_project_description")}
			>
				<Can
					action="delete"
					subject="Project"
				>
					<Button
						variant="ghost"
						onClick={disclosure.onOpen}
						data-cy="merge-project-button"
					>
						{t("projects.merge_project")}
					</Button>
				</Can>
			</SettingsItem>
			{disclosure.isOpen && (
				<MergeProjectModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					projectId={projectId}
					onComplete={() => {
						toast.success("MERGE COMPLETED");
					}}
				/>
			)}
		</React.Fragment>
	);
}
